import Basket from './Order_basket';
import CatalogDetail from './Catalog_detail';
import OrderDetail from './Order_detail';

export default {
  namespaced: true,
  modules   : {
    Basket,
    CatalogDetail,
    OrderDetail,
  },
};
